/**
 * Whether this render is the password form of a locked JobShop (JET-2155), and
 * why it is shown again if it is. Null for every ordinary page. Written once per
 * request by plugins/password-gate.server.ts, read by app.vue.
 */
export function usePasswordGate() {
  return useState<PasswordGateContext | null>("passwordGate", () => null)
}
